/**
 * Created by user on 2020/6/1.
 */

import table_cn2tw from './data/table_cn2tw';
import table_tw2cn from './data/table_tw2cn';

export * from './types';
import { IStaticDebugJSON, ITable } from './types';

export {
	table_cn2tw,
	table_tw2cn,
}

export default {
	table_cn2tw,
	table_tw2cn,
}
